import mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN = 'c5bf819a3b1497ff903a48d00ba9e69d';

export const initMixpanel = () => {
    mixpanel.init(MIXPANEL_TOKEN, {
        track_pageview: false,
        persistence: 'localStorage',
        record_sessions_percent: 100,
        record_mask_inputs: false,
        record_mask_all_text: false,
    });
    mixpanel.register({ platform: 'web' });
};

export const trackEvent = (eventName, properties = {}) => {
    mixpanel.track(eventName, properties);
};

export const identifyUser = (distinctId, profileProperties = {}) => {
    mixpanel.identify(distinctId);
    if (Object.keys(profileProperties).length > 0) {
        mixpanel.people.set(profileProperties);
    }
};

export const resetMixpanelUser = () => {
    mixpanel.reset();
};
